export default __webpack_public_path__ + "fonts/icomoon.dbdddc00de97f3f967f30babbd2cdc58.eot";